import React from 'react';
import { PurchaseConfirmationModalProvider } from '@apps/registry/guest/routes/Purchase/components/PurchaseConfirmationModal/PurchaseConfirmationModal.provider';
import { ShippingAddressFragment } from '@graphql/generated';
import { useFeatureValue } from '@shared/core/featureFlags';
import { useRouterHelper } from '@shared/core';
import { ShoppingCartProvider } from '../common/components/ShoppingCart/state';
import { CartCheckoutSteps } from '../common/components/ShoppingCart';

interface UseRegistryShoppingProps {
  skipShopping?: boolean;
}

const REGISTRY_CHECKOUT_STEPS_FLOW = [CartCheckoutSteps.Cart, CartCheckoutSteps.Shipping, CartCheckoutSteps.Payment];

export const RegistryShoppingProvider: React.FC<{ eventId?: string | null; eventHandle?: string | null; shippingAddress: ShippingAddressFragment | null }> = ({
  eventId,
  eventHandle,
  children,
  shippingAddress
}) => {
  return (
    <PurchaseConfirmationModalProvider>
      <ShoppingCartProvider coupleAddress={shippingAddress} eventHandle={eventHandle!} eventId={eventId!} checkoutStepsFlow={REGISTRY_CHECKOUT_STEPS_FLOW}>
        {children}
      </ShoppingCartProvider>
    </PurchaseConfirmationModalProvider>
  );
};

export const useRegistryShopping = ({ skipShopping }: UseRegistryShoppingProps = {}) => {
  const { isAdminRoute } = useRouterHelper();
  const { loading, value } = useFeatureValue('registryAdminShoppingEnabled', { skip: !isAdminRoute || skipShopping });
  const isEnabled = !loading && value === 'on';
  return { isEnabled };
};
